import React, { useEffect, useState } from "react";
import { TextField, Grid, Typography, Box, Button } from "@mui/material";
import { PhotoCamera, CloudUpload } from "@mui/icons-material";

type CustomProps = {
  name?: string;
  docTitle: string;
  path: string;
  height: number;
  width: number;
  show_message?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const CustomImagePicker: React.FC<CustomProps> = ({
  name,
  docTitle,
  path,
  height,
  width,
  show_message,
  onChange,
}) => {
  const containerStyle: React.CSSProperties = {
    //backgroundColor: "#131317",
    borderRadius: "20px",
    padding: "0px",
  };

  const labelStyle: React.CSSProperties = {
    marginBottom: "8px",
    fontWeight: "bold",
    fontSize: "16px",
  };

  const imageContainerStyle: React.CSSProperties = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    //minHeight: "200px",
    //marginBottom: "16px",
    border: "1px dashed #AFAFAF",
    padding: '22px',
    borderRadius: "20px",
    cursor: "pointer",
    width: "100%",
    height:'180px',
  };

  const uploadIconStyle: React.CSSProperties = {
    fontSize: "48px",
    color: "#797979",
    marginBottom: "8px", // Added margin for spacing
  };

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "auto",
    //width: "100%",
    //height: "auto",
    borderRadius: "20px",
    objectFit: "cover",
  };

  const [message, setMessage] = useState("Drag to upload image");

  useEffect(() => {
    if (show_message) setMessage(show_message);
  }, []);

  const handleImageClick = () => {
    // Handle image click event
  };

  return (
    <>
      <Box sx={containerStyle}>
        <Grid
          container
          spacing={0}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <label htmlFor={name}>
              <TextField
                id={name}
                type="file"
                name={name}
                onChange={onChange}
                InputProps={{
                  startAdornment: <PhotoCamera color="primary" />,
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "transparent",
                      },
                      "&:hover fieldset": {
                        borderColor: "transparent",
                      },
                    },
                  },
                }}
                fullWidth
                style={{ display: "none" }}
              />
              <Box
                component="div"
                sx={imageContainerStyle}
                onClick={handleImageClick}
              >
                {!path && (
                  <>
                    <img src="upload.png" style={{ width: '50px' }} />
                    {/* <CloudUpload style={uploadIconStyle} /> */}
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{ textAlign: "center", mt: "10px", fontSize: '14px', fontWeight: '300', color: '#797979', }}
                    >
                      {message}
                    </Typography>
                    <Typography sx={{ textAlign: "center", fontSize: '14px', fontWeight: '300', color: '#797979', }}>or</Typography>
                    <Box>
                      <Box sx={{
                        background:'#DCD732', 
                        fontSize: '14px', 
                        fontWeight: '400', 
                        marginTop:'7px',
                        color: '#000', 
                        borderRadius:'4px',
                        padding:'5px 24px',
                        "&:hover": {
                          background:'#000',
                          color:'#fff',
                        },
                        }}>
                        Browse
                      </Box>
                    </Box>
                  </>
                )}
                {path && <img src={path} alt="" style={imageStyle} />}
              </Box>
            </label>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ marginTop: '8px', fontSize:'14px', color:'#A5A5A5', textAlign:'center' }}>
        {docTitle}
      </Box>
    </>
  );
};

export default CustomImagePicker;
